<script>
/**
 * Imports
 */
import SignupSectionBasic from "./SignupSectionBasic.vue";
import SignupSectionCompany from "./SignupSectionCompany.vue";
import SignupSectionUsers from "./SignupSectionUsers.vue";
import SignupSectionPackages from "./SignupSectionPackages.vue";
import SignupSectionAgreement from "./SignupSectionAgreement.vue";

/**
 * Component: Sections
 *
 * @author PH
 */
export default {
  components: {
    SignupSectionBasic,
    SignupSectionCompany,
    SignupSectionUsers,
    SignupSectionPackages,
    SignupSectionAgreement
  }
};
</script>

<template>
  <div class="signup-sections">
    <signup-section-basic></signup-section-basic>
    <signup-section-company></signup-section-company>
    <signup-section-users></signup-section-users>
    <signup-section-packages></signup-section-packages>
    <signup-section-agreement></signup-section-agreement>
  </div>
</template>

